import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import BKButton from '@/components/AppShared/BKButton.vue'
import { IEvent } from '@/enitites/event'
import ToggleLike from '@/features/toggle-like/ui/ToggleLike.vue'
import { IEventFeedback, IEventFeedbackPostData } from '@/enitites/event/model/types'
import { useRouter } from 'vue-router/composables'
import { useEventFeedbackMutation } from '@/enitites/event/api/queries'
import { EVENT_STAR_CONFIG } from '../constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventFeedbackForm',
  props: {
    setFeedback: null,
    event: null,
    feedback: null
  },
  setup(__props: any) {

const props = __props as {
  setFeedback: (feedback: IEventFeedbackPostData) => void
  event: IEvent
  feedback: IEventFeedback | null
};



const router = useRouter()
const { mutateAsync, isPending } = useEventFeedbackMutation(props.event.id)

const isUpdate = computed(() => props.feedback)

const feedbackText = ref(props.feedback?.details || '')
const showValidationError = ref(false)

const ratingCategories = ref([
  { key: 'timeliness', label: 'Timeliness', value: props.feedback?.timeliness || 0 },
  { key: 'communication', label: 'Communication', value: props.feedback?.communication || 0 },
  { key: 'venue', label: 'Venue', value: props.feedback?.venue || 0 },
  { key: 'vibe', label: 'Vibe', value: props.feedback?.vibe || 0 },
  { key: 'musicSound', label: 'Music / Sound', value: props.feedback?.musicSound || 0 },
])

const isFormValid = computed(() => {
  return ratingCategories.value.every((category) => category.value > 0)
})

function handleFeedbackClose() {
  router.push({
    name: 'Event',
    params: { id: `${props.event?.id}` },
    query: { tab: 'info' },
  })
}

const handleSubmitFeedback = async () => {
  if (!isFormValid.value) {
    showValidationError.value = true
    return
  }

  showValidationError.value = false

  const ratings = Object.fromEntries(ratingCategories.value.map((cat) => [cat.key, cat.value])) as {
    timeliness: number
    communication: number
    venue: number
    vibe: number
    musicSound: number
  }

  const averageRating = (
    ratingCategories.value.reduce((sum, cat) => sum + cat.value, 0) / ratingCategories.value.length
  ).toFixed(2)

  const data: IEventFeedbackPostData = {
    averageRating: parseFloat(averageRating),
    timeliness: ratings.timeliness,
    communication: ratings.communication,
    musicSound: ratings.musicSound,
    venue: ratings.venue,
    vibe: ratings.vibe,
    details: feedbackText.value.trim(),
  }

  await mutateAsync({ data, isUpdate: !!isUpdate.value })
  handleFeedbackClose()
  props.setFeedback(data)
}

const handleRatingChange = () => {
  if (showValidationError.value && isFormValid.value) {
    showValidationError.value = false
  }
}

return { __sfc: true,props, router, mutateAsync, isPending, isUpdate, feedbackText, showValidationError, ratingCategories, isFormValid, handleFeedbackClose, handleSubmitFeedback, handleRatingChange, BKButton, ToggleLike, EVENT_STAR_CONFIG }
}

})